import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["boardButton", "listButton"]
  static values = {
    currentView: String
  }

  connect() {
    this.updateButtonStates()
  }

  async switchView(event) {
    event.preventDefault()
    const view = event.currentTarget.dataset.view
    const url = new URL(event.currentTarget.href)
    
    // Get existing query parameters
    const currentParams = new URLSearchParams(window.location.search)
    
    // Update the view parameter
    currentParams.set('view', view)
    
    // Update button states immediately
    this.currentViewValue = view
    this.updateButtonStates()

    try {
      // Fetch the new content with all parameters
      const response = await fetch(`${url.pathname}?${currentParams.toString()}`, {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html'
        }
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const html = await response.text()
      Turbo.renderStreamMessage(html)

      // Update URL in browser history
      const newURL = `${window.location.protocol}//${window.location.host}${url.pathname}?${currentParams.toString()}`
      window.history.pushState({}, '', newURL)
      window.Turbo.navigator.history.push(newURL)

    } catch (error) {
      console.error('Error:', error)
      // Revert button states on error
      this.currentViewValue = this.currentViewValue === 'board' ? 'list' : 'board'
      this.updateButtonStates()
    }
  }

  /**
   * If the current view is board, then the board button should be primary and the list button should be outline-primary
   * If the current view is list, then the list button should be primary and the board button should be outline-primary
   * If the current view is switchable, then the board button should be primary if the current view is not list and the list button should be primary if the current view is list
   */

  updateButtonStates() {
    this.boardButtonTarget.classList.toggle('btn-primary', this.currentViewValue !== 'list')
    this.boardButtonTarget.classList.toggle('btn-outline-primary', this.currentViewValue === 'list')
    this.listButtonTarget.classList.toggle('btn-primary', this.currentViewValue === 'list')
    this.listButtonTarget.classList.toggle('btn-outline-primary', this.currentViewValue !== 'list')
  }
} 